import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"


import { useState } from "react"
import { useNavigate } from "react-router-dom"

import Loading from "../../components/loading/loading"

import { ReactComponent as Info } from "../../assets/icons/generals/info.svg"
import { ReactComponent as View } from "../../assets/icons/generals/view.svg"
import { useRequestProcessor } from "../../api/requestProcessor"
import { getAllOrders } from "../../api/orders"
import OrderPaymentModal from "../../components/modal/orders/orderPayment"
import Pagination from "../../components/pagination/pagination"
import ViewOrderModal from "../../components/modal/view/view-order"






const Orders = () => {

    const naviagte = useNavigate()
    const [activeTab, setActiveTab] = useState(0)
    const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(1)

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
    
    const [selectedOrder, setSelectedOrder] = useState({})
    const [selectedDetailOrder, setSelectedDetailOrder] = useState({})

    const { Query, Mutate } = useRequestProcessor()



    function onConfirmHandler() {
        setIsModalOpen(false)
    }
    function onConfirmDetailHandler() {
        setIsDetailModalOpen(false)
    }


    const { data, isLoading, isError } = Query(
        ['getAllOrders', searchKeyword, page],
        () => getAllOrders(searchKeyword, page),
        { enabled: Boolean(searchKeyword) || searchKeyword == "" }
    );


    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    return (
        <Layout>
            <MainPageLayout title={"سفارشات"} >
                <div className="flex justify-between py-3 items-center  wsm:flex-col-reverse">
                    {isModalOpen && <OrderPaymentModal data={selectedOrder} onConfirm={onConfirmHandler} />}
                    {isDetailModalOpen && <ViewOrderModal data={selectedDetailOrder} onConfirm={onConfirmDetailHandler} />}
                    <div className="flex [&>*]:px-4 [&>*]:py-1 p-2 bg-[#eef3f7] rounded-lg text-[#5e6278]">
                        <button onClick={() => setActiveTab(0)} className={activeTab === 0 ? "bg-white rounded-lg text-black" : ""}>همه</button>
                        {/* <button onClick={() => setActiveTab(1)} className={activeTab === 1 ? "bg-white rounded-lg text-black" : ""}>جدید ترین</button>
                        <button onClick={() => setActiveTab(2)} className={activeTab === 2 ? "bg-white rounded-lg text-black" : ""}>قدیمی ترین</button> */}
                    </div>
                    {/* <div className="flex wsm:mb-4">

                        <input type="text" className='form-input !w-full' value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            placeholder='جستوجو سفارشات ...' />

                        <span className="flex text-sky-500 font-serif items-center mr-3 cursor-pointer">
                            <Filter width={24} height={24} />
                            فیلتر
                        </span>
                    </div> */}
                </div>
                <table className="table-auto transition-all" >
                    <thead className="!py-2">
                        <tr className=" border-b border-black">
                            <th className="py-3">#</th>
                            <th className="py-3">ایجاد شده توسط</th>
                            <th className="py-3">تخفیف</th>
                            <th className="py-3">قیمت</th>
                            <th className="py-3">تاریخ ایجاد</th>
                            <th className="py-3">وضعیت</th>
                            <th className="py-3">وضعیت پرداخت</th>
                            <th className="py-3">جزئیات</th>
                        </tr>
                    </thead>
                    {
                        !isLoading &&
                        <tbody>
                            {
                                data?.data?.length ?
                                    data?.data?.map(el => (
                                        <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                            <td className="text-center py-5" >{el.id}</td>
                                            <td className="text-center py-5" > {el.user?.name} {el.user?.lastname}</td>
                                            <td className="text-center py-5" >
                                                {
                                                    el.discount_amount && el.discount_amount !== "0" ? Intl.NumberFormat().format(+el.discount_amount) + " تومان" : "-"
                                                }
                                            </td>
                                            <td className="text-center py-5 " >
                                                <div className="bg-[#2196f3] py-2 text-white rounded-[1rem]">
                                                    {Intl.NumberFormat().format(+el.total_price) + " تومان"}
                                                </div>
                                            </td>
                                            <td className="text-center py-5" >
                                                <p>{el.created_at?.split(" ")[1]}</p>
                                                <p>{el.created_at?.split(" ")[0]}</p>
                                            </td>
                                            <td className="text-center py-5" > {el.status}</td>
                                            <td className="text-center py-5 flex  " >
                                                <div className="flex justify-evenly w-full">
                                                    {
                                                        el.is_paid ?
                                                            <p className="font-bold text-green-500">پرداخت شده</p>
                                                            :
                                                            <p className="font-bold text-red-500">پرداخت نشده</p>
                                                    }
                                                    <span className=" cursor-pointer" onClick={() => { setSelectedOrder(el); setIsModalOpen(true) }}>
                                                        <Info />
                                                    </span>
                                                </div>
                                            </td>
                                            <td className="text-center justify-center py-5" >
                                                <div className=" cursor-pointer flex justify-center"onClick={() => { setSelectedDetailOrder(el); setIsDetailModalOpen(true) }}><View width={"20"} height="20" /></div>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <div>
                                        <p>هیچ سفارشی پیدا نشد</p>
                                    </div>
                            }
                        </tbody>
                    }
                </table>
                {
                    isLoading && <Loading />
                }

                {data?.meta?.last_page > 1 && <Pagination options={page} handlePageClick={handlePageClick} lastPage={data?.meta?.last_page} />}

            </MainPageLayout>
        </Layout>
    )
}

export default Orders